import { useCallback } from "react";
import { useConfigurationDispatch, useConfigurationSelector, } from "../context/ConfigurationReduxContext";
import { selectIsItemExpanded } from "../reducers/Additional/configurationNavigationReducer";
import { setNavigationItems, toggleNavigationItem } from "../reducers/actions";
import { getNavigationExpandedState, getNavigationItemsList, getNavigationResetKey, } from "../reducers/selectors";
/**
 * NavigationState api
 * @private Avoid using this in projects
 */
export function useConfigurationNavigationApi() {
    const dispatch = useConfigurationDispatch();
    const toggleItem = useCallback((item, enable) => {
        dispatch(toggleNavigationItem(item, enable));
    }, [dispatch]);
    const setItems = useCallback((items) => {
        dispatch(setNavigationItems(items));
    }, [dispatch]);
    return {
        toggleItem,
        setItems,
    };
}
/**
 * NavigationState of a single item
 * @private Avoid using this in projects
 */
export function useConfigurationNavigationStateExpanded(item) {
    const expanded = useConfigurationSelector(getNavigationExpandedState);
    return selectIsItemExpanded(expanded, item);
}
/**
 * All expanded items
 * @returns
 * @private Avoid using this in projects
 */
export function useConfigurationNavigationItems() {
    return useConfigurationSelector(getNavigationItemsList);
}
/**
 * All expanded items
 * @returns
 * @private Avoid using this in projects
 */
export function useConfigurationResetKey() {
    return useConfigurationSelector(getNavigationResetKey);
}
//# sourceMappingURL=useConfigurationNavigationState.js.map